import { render, staticRenderFns } from "./BirthPlace.vue?vue&type=template&id=b377ad5e&"
import script from "./BirthPlace.vue?vue&type=script&lang=js&"
export * from "./BirthPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports